export const GET_REPORT_DATA = "GET_REPORT_DATA";
export const RESET_REPORT_DATA = "RESET_REPORT_DATA";
export const GET_REPORT_DATA_SUCCESS = "GET_REPORT_DATA_SUCCESS";
export const GET_REPORT_DATA_ERROR = "GET_REPORT_DATA_ERROR";
export const OPEN_REPORT_DIALOG = "OPEN_REPORT_DIALOG";
export const CLOSE_REPORT_DIALOG = "CLOSE_REPORT_DIALOG";
